module.exports = __webpack_public_path__ + "img/warning.0b328587.svg";